import { Temporal } from '@js-temporal/polyfill';

export function printDate(date: Temporal.ZonedDateTime | Temporal.PlainDate, include_weekday = true): string {
    const forcedGermanFormat = 'de-DE';
    let datePart = date.toLocaleString(forcedGermanFormat, {
        weekday: undefined,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
    if (include_weekday) {
        const forcedEnglishWeekdays = 'en-GB';
        const dow_en = date.toLocaleString(forcedEnglishWeekdays, { weekday: 'short' });
        datePart += `, ${dow_en}`;
    }
    if (date instanceof Temporal.PlainDate) {
        return datePart;
    } else {
        const timePart = date.toLocaleString(forcedGermanFormat, { hour: '2-digit', minute: '2-digit' });
        return `${datePart} | ${timePart}`;
    }
}

/**
 * This function can be useful when working with libs, that expect legacy Dates.
 * @param plainDate - without timezone
 * @returns A Legacy JS Date assuming local timezone
 */
export function temporalToLegacyDate(plainDate: Temporal.PlainDate): Date {
    const currTz = Temporal.Now.timeZoneId();
    const zoned = plainDate.toZonedDateTime({ timeZone: currTz });
    return new Date(zoned.epochMilliseconds);
}

/**
 *
 * @param legacy Date representing a point in time
 * @returns a plain date using the caller's time zone
 */
export function legacyDateToTemporal(legacy: Date): Temporal.PlainDate {
    const temp = Temporal.Instant.fromEpochMilliseconds(legacy.getTime());
    return temp.toZonedDateTimeISO(Temporal.Now.timeZoneId()).toPlainDate();
}

// Buckets match PBP_BOUNDARIES in charts as these are the standard
// PBDs given in the UCF
export const PBD_BOUNDARIES = [
    365, 91, 77, 63, 49, 42, 35, 28, 24, 21, 18, 16, 14, 12, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0,
];

export interface CurrentPBD {
    currentPBD: number;
    currentPBDBoundary: number;
}

export function calculatePBD(rideDeparture: Temporal.ZonedDateTime, rideDepartureTimezoneId: string): CurrentPBD {
    const rideDepartureTz = new Temporal.TimeZone(rideDepartureTimezoneId);
    const zonedRideDeparture = rideDeparture.withTimeZone(rideDepartureTz);
    const today = Temporal.Now.zonedDateTime(new Temporal.Calendar('iso8601'), rideDepartureTz);
    const untilDeparture = Math.round(zonedRideDeparture.until(today).hours / 24);
    let currentPBD = untilDeparture >= 0 ? 0 : untilDeparture;
    currentPBD = Math.abs(currentPBD);
    let currIdx = PBD_BOUNDARIES.length - 1;
    while (PBD_BOUNDARIES[currIdx - 1] <= currentPBD && currIdx > 0) {
        currIdx -= 1;
    }
    const currentPBDBoundary = PBD_BOUNDARIES[currIdx];
    return {
        currentPBD,
        currentPBDBoundary,
    };
}
